import { render, staticRenderFns } from "./BaHoldings.vue?vue&type=template&id=0e17b58e&"
import script from "./BaHoldings.vue?vue&type=script&lang=js&"
export * from "./BaHoldings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports